import { NGRXJwtState, jwtFeatureKey } from './jwt.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { JwtTokens, deserializeJwt } from '@wizbii-utils/angular/jwt';

export const selectJwt = createFeatureSelector<NGRXJwtState>(jwtFeatureKey);

export const jwtTokens = createSelector(selectJwt, (state) => state ?? undefined);
export const info = createSelector(selectJwt, (state) => (state?.token ? deserializeJwt(state.token) : null));
export const isLogged = createSelector(selectJwt, (state) => !!state);
export const userId = createSelector(selectJwt, (state) => {
  const jwt = state?.token && deserializeJwt(state.token) ? deserializeJwt(state.token) : null;
  return state?.token && jwt ? jwt['user-id'] : null;
});
export const roles = createSelector(selectJwt, (state) => {
  const jwt = state?.token && deserializeJwt(state.token) ? deserializeJwt(state.token) : null;
  return state?.token && jwt ? jwt['roles'] : null;
});
